module.exports = __webpack_public_path__ + "img/DTMElectric.4362c976.svg";